
import PartnershipHero from './components/PartnershipHero';
import PartnershipOptions from './components/PartnershipOptions';
import PartnershipBenefits from './components/PartnershipBenefits';
import PartnershipProcess from './components/PartnershipProcess';
import PartnershipFAQ from './components/PartnershipFAQ';
import PartnershipApplication from './components/PartnershipApplication';

export default function PartnershipPage() {
  return (
    <div className="min-h-screen">
      <PartnershipHero />
      <PartnershipOptions />
      <PartnershipBenefits />
      <PartnershipProcess />
      <PartnershipFAQ />
      <PartnershipApplication />
    </div>
  );
}
